<div class="inline-filter-container tile-container">
    <form [formGroup]="filterForm" class="inline-filter-form">
        <div class="inline-filter-field" *ngFor="let field of config.fields">
            <label>{{ field.label }}</label>

            <!-- Text Input -->
            <input
                *ngIf="field.type === 'text'"
                class="inline-form-control"
                [formControlName]="field.key"
                [placeholder]="
                    field.placeholder ||
                    'Select ' + field.label.toLowerCase() + '...'
                "
                type="text"
                (input)="onInlineFilterChange()"
            />

            <!-- Number Input -->
            <input
                *ngIf="field.type === 'number'"
                class="inline-form-control"
                [formControlName]="field.key"
                [placeholder]="
                    field.placeholder || 'Enter ' + field.label.toLowerCase()
                "
                type="number"
                (input)="onInlineFilterChange()"
            />

            <!-- Date Input -->
            <input
                *ngIf="field.type === 'date'"
                class="inline-form-control"
                [formControlName]="field.key"
                type="date"
                (change)="onInlineFilterChange()"
            />

            <!-- Select Dropdown -->
            <select
                *ngIf="field.type === 'select'"
                class="inline-form-control"
                [formControlName]="field.key"
                (change)="onInlineFilterChange()"
            >
                <option [value]="null" disabled selected>
                    {{
                        field.placeholder ||
                            'Select ' + field.label.toLowerCase() + '...'
                    }}
                </option>
                <option
                    *ngFor="let option of getFieldOptions(field)"
                    [value]="option.value"
                >
                    {{ option.label }}
                </option>
            </select>
        </div>

        <!-- Farm Filter (if enabled) -->
        <div class="inline-filter-field" *ngIf="config.showFarmFilter">
            <label>Farm</label>
            <select
                (change)="
                    onFarmChange($event.target.value); onInlineFilterChange()
                "
                formControlName="farmId"
                class="inline-form-control"
            >
                <option value="0">Select farm...</option>
                <option *ngFor="let farm of farmlist" [value]="farm.id">
                    {{ farm.name }}
                </option>
            </select>
        </div>

        <!-- House Filter (if enabled) -->
        <div class="inline-filter-field" *ngIf="config.showHouseFilter">
            <label>House</label>
            <select
                class="inline-form-control"
                formControlName="farmHouseId"
                (change)="
                    onHouseChange($event.target.value); onInlineFilterChange()
                "
            >
                <option value="0">Select house...</option>
                <option
                    *ngFor="let farmhouse of farmhouselist"
                    [value]="farmhouse.id"
                >
                    {{ farmhouse.name }}
                </option>
            </select>
        </div>

        <!-- Partition Filter (if enabled) -->
        <div class="inline-filter-field" *ngIf="config.showPartitionFilter">
            <label>Partition</label>
            <select
                class="inline-form-control"
                formControlName="partitionId"
                (change)="onInlineFilterChange()"
            >
                <option value="0">Select partition...</option>
                <option
                    *ngFor="let partition of partitionlist"
                    [value]="partition.id"
                >
                    {{ partition.name }}
                </option>
            </select>
        </div>

        <!-- Clear Filter Button -->
        <div class="inline-filter-actions">
            <button
                type="button"
                class="btn btn-clear"
                (click)="clearFilter()"
                title="Clear filters"
            >
                <i class="fas fa-sync-alt"></i>
            </button>
        </div>
    </form>
</div>
